import { connect } from 'react-redux';

import { getContractFile } from '../actions/license';

import { LicenseDetail } from '../components/license-list';

const mapDispatch = {
  getContractFile
};

export default connect(
  null,
  mapDispatch
)(LicenseDetail);
